import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

export const removeLocalePrefixFromPath = (path: string) => {
  const locales = Object.values(PageLocaleEnum).join('|')
  const localeRegex = new RegExp(`^(?:${locales})\\b\\/`)
  return path.replace(localeRegex, '')
}
